import React, { useState, useRef } from 'react';
import DatePicker from 'react-datepicker';
import Spacing from '../Spacing';
import { notify, datePickerFormat } from "../../helpers";
import { Drawer } from 'vaul';
import { Loader } from 'lucide-react';
import { addClinicalPatients } from '../../services/clinicalNotes';

export default function AddClinicalPatientModal(props) {
  const {    
    reloadData = () =>{},
    reloadDataFilter = {},
    account_id,
    location_id,
    clinicalNoteAdd = {},
    setClinicalNoteAdd = () => {},
    previousScrollPosition = 0,
  } = props;

  const defaultValues = {
    account_id:account_id,
    location_id:location_id,
    first_name: "",
    last_name: "",
    dob: "",
    gender: "Male",
    diagnoses: "",
    dos: "",
    emr_patient_id: "",
  }

  const [formData, setFormData] = useState(defaultValues);
  const [saveLoader, setSaveLoader] = useState(false);
  const dropdownRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleChangeDate = (name, value) => {
    setFormData({
      ...formData,
      [name]: datePickerFormat(value),
    });  
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaveLoader(true);

    try {
      const response = await addClinicalPatients(formData);
      
      if (response?.detail) {
        notify('error', response?.detail, 2);
      } else { 
        if(response?.data?.status === 'success'){
          notify("success", response?.data?.message, 2);
          setFormData(defaultValues);
          reloadData(reloadDataFilter);
          handleDrawerClose();
        } else {
          notify("error", response?.data?.message, 2);
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 2);
      }
    } finally {
      setSaveLoader(false);
    }
  };

  const handleDrawerClose = () => {
    setClinicalNoteAdd(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={clinicalNoteAdd} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn"></Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Add Patient</Drawer.Title>
            <Drawer.Description className="sr-only">Add a new patient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_modal_lg center">
              <div className="docpro_modal">
                <h2 className="docpro_fs_24">Add Patient</h2>

                <form onSubmit={handleSubmit} autoComplete={false}>            
                  <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3 input">
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Last Name <span className="docpro_red_color">*</span>
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='last_name' required onChange={handleChange} value={formData.last_name} />
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        First Name <span className="docpro_red_color">*</span>
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='first_name' required onChange={handleChange} value={formData.first_name} />
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Date of Birth <span className="docpro_red_color">*</span>
                      </label>
                      <DatePicker
                        name='dob'
                        selected={formData.dob}
                        className="size_lg"
                        placeholderText='mm/dd/yyyy'
                        onChange={date => handleChangeDate("dob",date)}
                        required
                      />
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Gender <span className="docpro_red_color">*</span>
                      </label>
                      <select className="docpro_form_field size_lg" name='gender' required onChange={handleChange} >
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Others">Others</option>
                      </select>
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Date of Service <span className="docpro_red_color">*</span>
                      </label>
                      <DatePicker
                        name='dos'
                        selected={formData.dos}
                        className="size_lg"
                        placeholderText='mm/dd/yyyy'
                        onChange={date => handleChangeDate("dos",date)}
                        required                  
                      />
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        EMR Patient Id
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='emr_patient_id' onChange={handleChange} value={formData.emr_patient_id}/>
                    </div>
                  </div>

                
                  <Spacing lg="20" sm="20" />
                  <label className="docpro_fw_500 docpro_primary_color">
                    Diagnoses
                  </label>
                  <textarea
                    minLength={2}
                    name="diagnoses"
                    className="docpro_form_field size_lg"
                    cols="30"
                    rows="5"
                    value={formData.diagnoses}
                    onChange={handleChange}
                    placeholder="Overweight(E66.3),Hyperlipidemia(E78.5)"
                  ></textarea>

                  <Spacing lg="32" sm="32" />
                  <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                    <button
                      className="docpro_bordered_btn docpro_fw_600 size_lg"
                      onClick={() => handleDrawerClose()}
                    >
                      Cancel
                    </button>
                    <button
                      type='submit'
                      className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                      disabled={saveLoader ? true : false}
                    >
                      Save
                      {saveLoader && (
                        <span className="docpro_loading">
                          <Loader width={20} height={20} />
                        </span>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
